import sdl from '@jds/react-generated-sdl/JDSSearchResultItem';
import type { JDSSearchResultItemProps } from './interface';

import { componentsMap } from '../../../generators/componentMap';
import {
  createComponent,
  getCustomJSON,
  useTokenValues
} from '@jds/react-engine';

import { withLogic } from '../logic';

const Component = (props: JDSSearchResultItemProps) => {
  const { platform } = useTokenValues();

  const json = sdl;
  const {
    ariaLabel = props.label?.toString(),
    custom = '',
    ...rest
  } = props as any;
  return createComponent(
    json,
    { ariaLabel, ...rest },
    'JDSSearchResultItem',
    componentsMap,
    getCustomJSON(custom || '') || {}
  );
};

const SearchResultItem = withLogic(
  Component
) as React.FC<JDSSearchResultItemProps> & { slotName?: string };

SearchResultItem.displayName = 'SearchResultItem';
SearchResultItem.slotName = 'jds_search_result_item';

export { SearchResultItem, type JDSSearchResultItemProps };
